import { dependabilityV2Colors } from '@/styles/colors';

// One tier color per tier, shared by the tier pill, the popover's highlighted
// segment AND the score ring (arc + digits) — GRAVY-10233 removed the ring's
// separate per-tier accent so a single tier color appears across the card.
const TIER_COLORS: Record<string, string> = {
  monitored: dependabilityV2Colors.depTierMonitored,
  standard: dependabilityV2Colors.depTierStandard,
  gold: dependabilityV2Colors.depTierGold,
  platinum: dependabilityV2Colors.depTierPlatinum,
};

const FALLBACK = '#6C757D';

export const tierColor = (tier: string | null | undefined): string =>
  (tier && TIER_COLORS[tier]) || FALLBACK;

export const categoryColor = (
  category: 'positive' | 'negative' | 'neutral',
): string => {
  if (category === 'positive') return dependabilityV2Colors.depPositive;
  if (category === 'negative') return dependabilityV2Colors.depTierMonitored;
  return FALLBACK;
};

// Activity-feed accent bars use a third palette: green / amber / red for
// positive / neutral / negative entries ("Late checked in" arrives as a
// neutral checkin_recorded event, which is exactly the design's amber case).
export const feedAccentColor = (
  category: 'positive' | 'negative' | 'neutral',
): string => {
  if (category === 'positive') return dependabilityV2Colors.depFeedPositive;
  if (category === 'negative') return dependabilityV2Colors.depTierMonitored;
  return dependabilityV2Colors.depFeedNeutral;
};
